module.exports = __webpack_public_path__ + "img/img_chat.0287b205.png";